import { useCallback } from 'react'
import { useStandardTrack } from './use-standard-track'

export type FormName = 'find-your-advisor' | 'schedule_form' | 'wealth-check' | 'worthwhile-spend-check'

type TrackFormActionParams = {
  questionName: string
  questionValue: string | boolean | number | string[] | undefined | null
  formName: FormName
  stepName?: string
}

export const useTrackFormAction = () => {
  const track = useStandardTrack()

  return useCallback(
    (params: TrackFormActionParams) => {
      let transformedValue: TrackFormActionParams['questionValue'] = params.questionValue
      if (typeof params.questionValue === 'string') {
        transformedValue = params.questionValue.replace(/_/g, '-')
      } else if (Array.isArray(params.questionValue)) {
        transformedValue = params.questionValue
          .map((item) => item.replace(/_/g, '-'))
          .sort()
          .join(',')
      }

      const base = {
        form_action: 'step-submitted' as const,
        form_name: params.formName,
        field: params.questionName,
        ...(params.stepName ? { step_name: params.stepName } : {}),
      }

      if (typeof transformedValue === 'string' || typeof transformedValue === 'number') {
        track('Form Action', { ...base, field_value: transformedValue })
        return
      }

      if (transformedValue !== undefined) {
        track('Form Action', {
          ...base,
          additional_attributes: { field_value: transformedValue },
        })
        return
      }

      track('Form Action', base)
    },
    [track]
  )
}
